export const getEmail = state => state.getIn(['confirmEmail', 'email']);

export const getPassword = state => state.getIn(['confirmEmail', 'password']);

export const getIsResending = state => state.getIn(['confirmEmail', 'resending']);
